import { createApp } from 'vue'

import Index from './topic.vue'
import { Vue3Mq } from "vue3-mq";

window.$ = window.jQuery = require('jquery');

//const { MqResponsive, Vue3Mq: Vue3MqPlugin } = Vue3Mq;
const app = createApp(Index)
//app.use(VueNextSelect);
//app.use(router)
app.use(Vue3Mq);
app.mount('#main')
